import { ICalltracking } from './types';

export const defaultState: ICalltracking = {
  isAvailable: false,
  isEnabled: false,
  isCompulsory: false,
  period: null,
  incompatibleServices: [],
  calltrackingPhoneSubstitutionsCount: null,
};
